module.exports = __webpack_public_path__ + "img/success-image.94657eb9.png";